export default {"src":"/_next/static/media/twitter_icon.2a6bc158.svg","height":70,"width":76,"blurWidth":0,"blurHeight":0};